import { StrategyBaseClass } from './strategy-base-class.js';

export class TiktokService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 21;
  }

  getTypeString() {
    return 'tiktok';
  }

  getAllTasksTypes() {
    return this.getPublicTaskTypes();
  }

  getPublicTaskTypes() {
    return [47];
  }

  getTaskTypeString(taskType) {
    const mapping = {
      47: 'tiktok/comments',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    const mapping = {
      47: 'tiktok-comments',
    };
    return mapping[taskType];
  }

  static TiktokFactory($translate) {
    return new TiktokService($translate);
  }
}
TiktokService.TiktokFactory.$inject = ['$translate'];
